<pannel [title]="getTitle()" [expandable]="true" [folded]="foldedPannel" 
	[ngClass]= "highlightable && dataSource.data.length > 0 && isCacOrCc() ? 'highlightable' : ''" >
	<div class="mat-elevation-z4">
		<table mat-table matSort [dataSource]="dataSource" style="width: 100%" class="acces-liste">

			<ng-container matColumnDef="numero">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Numéro </th>
				<td mat-cell *matCellDef="let acces"> {{ acces.numero }}</td>
			</ng-container>
			
			<ng-container matColumnDef="antenneNom">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Antenne </th>
				<td mat-cell *matCellDef="let acces"> {{ acces.antenneNom }}</td>
			</ng-container>
			
			<ng-container matColumnDef="parcCode">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Parc </th>
				<td mat-cell *matCellDef="let acces"> 
					<i class="parc-energie fa {{ acces.parcIcon }}" title="{{ acces.parcEnergie }}"></i>{{ acces.parcCode }} ({{ acces.parcDescription }})
				</td>
			</ng-container>
			
			<ng-container matColumnDef="ouvrageNoms">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Ouvrage(s) </th>
				<td mat-cell *matCellDef="let acces" title="{{ acces.ouvrageNoms }}">
					<etat-ouvrage [accesId]="acces.id" [ouvrageNoms]="acces.ouvrageNoms" *ngIf="title === 'Accès Terminé'" ></etat-ouvrage>
					<span *ngIf="title !== 'Accès Terminé'">{{ acces.ouvrageNoms | truncate:[24, '...'] }}</span>
				</td>
			</ng-container>
			
			<ng-container matColumnDef="ouvrageConcernes">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Ouvrage(s) concerné(s) </th>
				<td mat-cell *matCellDef="let acces" title="{{ acces.ouvrageConcernes }}"> {{ acces.ouvrageConcernes | truncate:[24, '...'] }} </td>
			</ng-container>
			
			<ng-container matColumnDef="etat">
				<th mat-header-cell *matHeaderCellDef> &nbsp;Etat&nbsp; </th>
				<td mat-cell *matCellDef="let acces">
					<i class="fa fa-calendar fa-lg" alt="Planifié" title="Planifié" *ngIf="acces.etat==='ETAT_ENREGISTRE'"></i>
					<i class="fa-regular fa-circle-question fa-lg en-attente" alt="Entrée demandée" title="Entrée demandée" *ngIf="acces.etat==='ETAT_DEMANDE_ENTREE'"></i>
					<i class="fa-regular fa-clock fa-lg text-active" alt="En cours" title="En cours" *ngIf="acces.etat==='ETAT_EN_COURS' && acces.etatDemandeFermeture === null"></i>
					<i class="fa fa-pause fa-lg text-active" alt="En attente de fermeture" title="En attente de fermeture" *ngIf="acces.etat==='ETAT_EN_COURS' && acces.etatDemandeFermeture === 0"></i>
					<i class="fa-regular fa-square-check fa-lg text-success" alt="Terminé" title="Termin&eacute;" *ngIf="acces.etat==='ETAT_TERMINE'"></i>
					<i class="fa fa-minus-circle fa-lg text-alert" alt="Refusé" title="Refusé" *ngIf="acces.etat==='ETAT_REFUSE'"></i>
					<i class="fa fa-eraser fa-lg" style="color: black" alt="En erreur / annulé" title="En erreur / annulé" *ngIf="acces.etat==='ETAT_ERREUR'"></i>
				</td>
			</ng-container>
			
			<ng-container matColumnDef="cac">
				<th mat-header-cell *matHeaderCellDef > Valideur </th>
				<td mat-cell *matCellDef="let acces">
					{{ acces.valideurNom ? acces.valideurNom : acces.cacNom }} {{ acces.etat==='ETAT_ENREGISTRE' && acces.ccNom ? ' / ' + acces.ccNom : '' }}
				</td>
			</ng-container>
			
			<ng-container matColumnDef="entrepriseNoms">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Entreprise </th>
				<td mat-cell *matCellDef="let acces" title="{{ acces.entrepriseNoms }}">{{ acces.entrepriseNoms | truncate:[24, '...'] }} </td>
			</ng-container>
			
			<ng-container matColumnDef="chargeAcces">
				<th mat-header-cell *matHeaderCellDef > Intervenants </th>
				<td mat-cell *matCellDef="let acces" title="{{ acces.intervenants }}">{{ acces.intervenants | truncate:[24, '...'] }}</td>
			</ng-container>
			
			<ng-container matColumnDef="dateDebut">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Début </th>
				<td mat-cell *matCellDef="let acces"> {{ acces.dateDebut  | localDateTimeToDate: acces.ice | date : 'dd/MM/yyyy HH:mm' }}</td>
			</ng-container>
			
			<ng-container matColumnDef="dateAutorisation">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Autorisé le </th>
				<td mat-cell *matCellDef="let acces"> {{ acces.dateAutorisation  | localDateTimeToDate: acces.ice | date : 'dd/MM/yyyy HH:mm' }}</td>
			</ng-container>
			
			<ng-container matColumnDef="dateFin">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Fin </th>
				<td mat-cell *matCellDef="let acces"> {{ acces.dateFin  | localDateTimeToDate: acces.ice | date : 'dd/MM/yyyy HH:mm' }}</td>
			</ng-container>
			
			<ng-container matColumnDef="dateErreur">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Date Erreur / Annulation </th>
				<td mat-cell *matCellDef="let acces"> {{ acces.dateFin  | localDateTimeToDate: acces.ice | date : 'dd/MM/yyyy HH:mm' }}</td>
			</ng-container>
			
			<ng-container matColumnDef="controleSecurite">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Contrôle sécurité </th>
				<td mat-cell *matCellDef="let acces">
					<span title="{{ acces.controleSecurite ? controleSecuriteLabels[acces.controleSecurite] : '' }}">
						{{ acces.controleSecurite ? controleSecurite[acces.controleSecurite] : '' }}
					</span>
				</td>
			</ng-container>
			
			<ng-container matColumnDef="dateFermeture">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Date Refus </th>
				<td mat-cell *matCellDef="let acces"> {{ acces.dateFermeture  | localDateTimeToDate: acces.ice | date : 'dd/MM/yyyy HH:mm' }}</td>
			</ng-container>
			
			<ng-container matColumnDef="motifRefus">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Cause </th>
				<td mat-cell *matCellDef="let acces"> {{ applicationConstants.motifRefus[acces.motifRefus - 1] }}</td>
			</ng-container>
			
			<ng-container matColumnDef="operationIds">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Référence externe et acte O&M </th>
				<td mat-cell *matCellDef="let acces" class="popover__wrapper">
					<span *ngFor="let operationId of acces.operations">{{ operationId }}<br/></span>
					<span *ngFor="let workorderNumber of acces.workorderNumbers">{{ workorderNumber }}<br/></span>
					<span *ngFor="let notificationNumber of acces.notificationNumbers">{{ notificationNumber }}<br/></span>
					<div class="popover__content">
						<div class="panel panel-default">
							<div class="panel-heading" role="document">
								<h3>Acces {{acces.numero}}</h3>
							</div>
							<div class="panel-body">
								<div class="section">
									<div class="title">Commentaire:</div>
									<span class="field with-break-word">{{ acces.etat === 'ETAT_TERMINE' ? acces.commentaireFermeture : acces.commentaire }}</span>
								</div>
								<div class="section" *ngIf="acces.acteOnm">
									<div class="title">Opérations:</div>
									<ul>
										<ng-container *ngFor="let acte of split(acces.acteOnm, ';')">
										       <li class="field">{{ acte }}</li>
										</ng-container>
									</ul>
								</div>
								<div class="section" *ngIf="acces.listWorkorders.length === 0">
									<div class="title">Work Orders:</div>
									<span class="field">Aucun Work Order lié</span>
								</div>
								<div class="section" *ngIf="acces.listWorkorders.length > 0">
									<div class="title">Work Orders:</div>
									<ul>
										<li class="field" *ngFor="let wo of acces.listWorkorders">{{ wo }}</li>
									</ul>
								</div>
								<div class="section" *ngIf="acces.listNotifications.length === 0">
									<div class="title">Notifications:</div>
									<span class="field">Aucune notification liée</span>
								</div>
								<div class="section" *ngIf="acces.listNotifications.length > 0">
									<div class="title">Notifications:</div>
									<ul>
										<li class="field" *ngFor="let notification of acces.listNotifications">{{ notification }}</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</td>
			</ng-container>
			
			<ng-container matColumnDef="actions">
				<th mat-header-cell *matHeaderCellDef> Actions </th>
				<td mat-cell *matCellDef="let acces" class="actions">
					<ng-container *ngIf="canAccessActions(acces); else disabledActions">
						<ng-container *ngIf="restrictActionsToCacCc; else allActions">
							<a title="Fermer l'accès" (click)="requestAction(accesAction.FERMER, acces)" click-stop-propagation *ngIf="acces.etat === 'ETAT_EN_COURS' && !acces.hasDemandeFermeture">
								<i class="fa-regular fa-hand fa-lg text-active"></i>
							</a>
							<a title="Autoriser la fermeture" (click)="approveDemandeFermeture(acces)" click-stop-propagation *ngIf="acces.etat === 'ETAT_EN_COURS' && (user.id === acces.cacId || user.id === acces.ccId)">
								<i class="fa-regular fa-thumbs-up fa-lg text-success"></i>
							</a>
							<a title="Refuser la fermeture" (click)="denyDemandeFermeture(acces)" click-stop-propagation *ngIf="acces.etat === 'ETAT_EN_COURS' && (user.id === acces.cacId || user.id === acces.ccId)">
								<i class="fa-regular fa-thumbs-down fa-lg text-active"></i>
							</a>
						</ng-container>
						<ng-template #allActions>
							<ng-container
								[ngTemplateOutlet]="acces.parcActif ? someActions : noAction"
								[ngTemplateOutletContext]="{ data: acces }">
							</ng-container>
						</ng-template>
			
					</ng-container>
			
					<ng-template #disabledActions>
						<i class="fa-regular fa-lock text-disable"></i>
					</ng-template>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let acces columns: displayedColumns" 
			    (click)="onRowClicked(acces)" 
			    [ngClass]="{'with-red-bg': acces.etat === 'ETAT_EN_COURS' && !(acces.jobExecutionId && acces.ice), 'purple-ice-row': coactivitePilotageEcoSelected && acces.etat === 'ETAT_EN_COURS' && (acces.jobExecutionId || acces.ice)}">
			</tr>
		</table>
		<mat-paginator #paginator
			showFirstLastButtons
			[pageSizeOptions]="[10, 20, 50, 100]"
			[pageSize]="pageSize"
			aria-label="Choisissez une page">
		</mat-paginator>
	</div>		
	<div class="navbar">
		<button type="button" class="btn btn-primary" (click)="exportRequest$.next()">Exporter</button>
	</div>
</pannel>


<ng-template #noAction let-data="data">
	<span class="text-active">Parc inactif </span>
</ng-template>

<ng-template #someActions let-data="data">
	<a title="Autoriser l'accès"  (click)="requestAction(accesAction.OUVRIR_CONTROLE_SECURITE, data)" click-stop-propagation
		*ngIf="(data.etat === 'ETAT_ENREGISTRE' || data.etat === 'ETAT_DEMANDE_ENTREE') && (user.id === data.cacId || (user.id === data.ccId && data.typeAcces === 'A_DISTANCE')) && !data.entrepriseSeuls && autorisationPossible(data)">
		<i class="fa-regular fa-thumbs-up fa-lg text-success"></i>
	</a>
	<a title="Autorisation impossible, intervenants non renseignés" click-stop-propagation
		*ngIf="(data.etat === 'ETAT_ENREGISTRE' || data.etat === 'ETAT_DEMANDE_ENTREE') && (user.id === data.cacId || (user.id === data.ccId && data.typeAcces === 'A_DISTANCE')) && data.entrepriseSeuls && autorisationPossible(data)">
		<i class="fa-regular fa-thumbs-up fa-lg text-disable"></i>
	</a>
	<a title="Vous ne pouvez pas autoriser un accès dans le futur" click-stop-propagation
		*ngIf="(data.etat === 'ETAT_ENREGISTRE' || data.etat === 'ETAT_DEMANDE_ENTREE') && (user.id === data.cacId || (user.id === data.ccId && data.typeAcces === 'A_DISTANCE')) && !data.entrepriseSeuls && !autorisationPossible(data)">
		<i class="fa-regular fa-thumbs-up fa-lg text-disable"></i>
	</a>
	<a title="Refuser l'accès" (click)="requestAction(accesAction.REFUSER, data)" click-stop-propagation
		*ngIf="(data.etat === 'ETAT_ENREGISTRE' || data.etat === 'ETAT_DEMANDE_ENTREE') && (user.id === data.cacId || (user.id === data.ccId && data.typeAcces === 'A_DISTANCE')) && !data.entrepriseSeuls && refusPossible(data)">
		<i class="fa-regular fa-thumbs-down fa-lg text-active"></i>
	</a>
	<a title="Refus impossible, intervenants non renseignés" click-stop-propagation
		*ngIf="(data.etat === 'ETAT_ENREGISTRE' || data.etat === 'ETAT_DEMANDE_ENTREE') && (user.id === data.cacId || (user.id === data.ccId && data.typeAcces === 'A_DISTANCE')) && data.entrepriseSeuls && refusPossible(data)">
		<i class="fa-regular fa-thumbs-down fa-lg text-disable"></i>
	</a>
	<a title="Vous ne pouvez pas refuser un accès dans le futur" click-stop-propagation
		*ngIf="(data.etat === 'ETAT_ENREGISTRE' || data.etat === 'ETAT_DEMANDE_ENTREE') && (user.id === data.cacId || (user.id === data.ccId && data.typeAcces === 'A_DISTANCE')) && !data.entrepriseSeuls && !autorisationPossible(data)">
		<i class="fa-regular fa-thumbs-down fa-lg text-disable"></i>
	</a>
	<a title="Fermer l'accès" (click)="requestAction(accesAction.FERMER, data)" click-stop-propagation
		*ngIf="data.etat === 'ETAT_EN_COURS' && !data.hasDemandeFermeture">
		<i class="fa-regular fa-hand fa-lg text-active"></i>
	</a>
	<a title="Autoriser la fermeture" (click)="requestAction(accesAction.FERMER, data)" click-stop-propagation
		*ngIf="data.etat === 'ETAT_EN_COURS' && (user.id === data.cacId || user.id === data.ccId ) && data.hasDemandeFermeture">
		<i class="fa-regular fa-thumbs-down fa-lg text-success"></i>
	</a>
	<a title="Refuser la fermeture" (click)="requestAction(accesAction.REFUSER_FERMETURE, data)" click-stop-propagation
		*ngIf="data.etat === 'ETAT_EN_COURS' && (user.id === data.cacId || user.id === data.ccId ) && data.hasDemandeFermeture">
		<i class="fa-regular fa-thumbs-up fa-lg text-success"></i>
	</a>
	<a title="Modifier l'accès" (click)="requestAction(accesAction.MODIFIER, data)" click-stop-propagation
		*ngIf="data.etat !== 'ETAT_TERMINE' && data.etat !== 'ETAT_ERREUR' && canUpdate(data)">
		<i class="fa-regular fa-pen-to-square fa-lg text-active"></i>
	</a>
	<a title="Modifier l'accès" (click)="requestAction(accesAction.FERMER, data)" click-stop-propagation
		*ngIf="data.etat === 'ETAT_TERMINE' && canUpdate(data)">
		<i class="fa-regular fa-pen-to-square fa-lg text-active"></i>
	</a>
	<a title="Classer l'accès en erreur" (click)="requestAction(accesAction.CLASSER_EN_ERREUR, data)" click-stop-propagation
		*ngIf="data.etat === 'ETAT_EN_COURS' && (user.id === data.cacId || (user.id === data.ccId && data.typeAcces === 'A_DISTANCE')) && !data.hasDemandeFermeture">
		<i class="fa fa-eraser fa-lg" style="color: black"></i>
	</a>
	<a title="Associer des arrêts" (click)="requestAction(accesAction.ASSOCIER_ARRETS, data)" click-stop-propagation 
		*ngIf="(data.etat === 'ETAT_EN_COURS' || data.etat === 'ETAT_TERMINE') && data.hasCausedArrets"
		[ngClass]="data.signalerAbsenceArrets ? 'inactive' : (data.hasArrets ? '' : 'active')" >
		<i class="fa fa-link fa-lg"></i>
	</a>
	<a title="Associer des opérations" (click)="requestAssociation(data)" click-stop-propagation
		*ngIf="data.etat === 'ETAT_EN_COURS' || data.etat === 'ETAT_TERMINE'"
		[ngClass]="{'inactive': data.aucunActeAssociable,'active': !data.aucunActeAssociable && !data.hasOperations}" >
		<i class="fa fa-briefcase fa-lg"></i>
	</a>
	<a title="Supprimer l'accès" (click)="requestAction(accesAction.SUPPRIMER, data)" *ngIf="canDelete(data)" click-stop-propagation >
		<i class="fa fa-trash fa-lg text-active"></i>
	</a>
	<a title="Dupliquer" (click)="requestAction(accesAction.DUPLIQUER, data)" *ngIf="!data.ice" click-stop-propagation >
		<i class="fa fa-clone fa-lg"></i>
	</a>
	<a title="Indiquer un rappel" (click)="requestAction(accesAction.INDIQUER_RAPPEL, data)" click-stop-propagation
		*ngIf="data.etat === 'ETAT_EN_COURS' && !data.ice"
		class="popover__wrapper">
		<i class="fa fa-phone fa-lg" [style.color]="etatRappelColors[data.etatRappelIntervenants]"></i>
		<div class="popover__content">
			<div class="panel panel-default">
				<div class="panel-heading" role="document">
					<h3>Rappel des intervenants</h3>
				</div>
				<div class="panel-body">
					<div class="section" *ngIf="data.etatRappelIntervenants === 'NON'">
						Les intervenants de cet acc&egrave;s n'ont pas &eacute;t&eacute; rappel&eacute;s.
					</div>
					<div class="section" *ngIf="data.etatRappelIntervenants != 'NON'">
						<div class="title">Date / Heure de rappel :</div>
						<span class="field">{{ data.dateRappelIntervenants  | localDateTimeToDate: false | date : 'dd/MM/yyyy HH:mm' }}</span>
					</div>
				</div>
			</div>
		</div>
	</a>
</ng-template>
